import React from 'react'
import OralScoreTag from 'components/Patients/Timeline/V2/Tags/OralScoreTag'
import useScanOralScore from 'components/Patients/Timeline/V2/useScanOralScore'
import OralScoreFrozenIndicator from 'components/Patients/Timeline/V2/OralScoreFrozenIndicator'
import { Skeleton } from '@material-ui/lab'
import { Grid } from '@material-ui/core'

const OralHygiene = ({ latestScanTimelineItems, isLoading }) => {
  const latestScan = latestScanTimelineItems[latestScanTimelineItems.length - 1]
  const oralHygieneScore = useScanOralScore({ oralScores: latestScan?.payload?.oralScores })
  const rawOralScores = latestScan?.payload?.oralScores

  return isLoading ? (
    <Skeleton variant="rect" width={70} height={24} style={{ borderRadius: 8 }} />
  ) : oralHygieneScore?.hygieneScore ? (
    <Grid container direction="row" alignItems="center" wrap="nowrap">
      <Grid item>
        <OralScoreTag
          scoreValue={oralHygieneScore.hygieneScore}
          withIcon
          withBackground={false}
          withTitle={false}
          iconSize={24}
          fontSize={16}
        />
      </Grid>
      <Grid item style={{ marginLeft: 4 }}>
        <OralScoreFrozenIndicator oralScores={rawOralScores} />
      </Grid>
    </Grid>
  ) : (
    <></>
  )
}

export default OralHygiene
